import { MoreVertical } from "lucide-react"

import { Button, ButtonProps } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

type Props = {
  dropdownMenuContent: React.ReactNode
  isDisabled?: boolean
  isLoading?: boolean
  mainActionButton: React.ReactNode
  variant?: ButtonProps["variant"]
}

export function ButtonWithOptions({
  dropdownMenuContent,
  isDisabled = false,
  isLoading = false,
  mainActionButton,
  variant,
}: Props) {
  return (
    <div className="inline-flex rounded-md shadow-xs" role="group">
      {mainActionButton}
      <DropdownMenu>
        <DropdownMenuTrigger asChild disabled={isDisabled || isLoading}>
          <Button
            type="button"
            className="rounded-none rounded-r border-l-0"
            isDisabled={isDisabled}
            variant={variant}
            size="icon"
          >
            <MoreVertical className="size-6" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-64" align="end">
          {dropdownMenuContent}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
